import { CalendarCacheScenarioId } from './CalendarCacheScenarioId';
import { ObservableMap } from 'mobx';

export enum CalendarCacheInitializationLoadState {
    Loaded,
    Loading,
    NotLoaded,
}

export interface CalendarCacheInitializationState {
    calendarCacheInitializationLoadState: ObservableMap<
        string,
        CalendarCacheInitializationLoadState
    >;
    calendarCacheInitializationLoadingScenarios: CalendarCacheScenarioId[];
}
